import { createSlice } from '@reduxjs/toolkit';
const name = 'saleBoard';

const initialState = {
  saleAmount: 0,
  soldedNumNormal: 0,
  soldedNumRare: 0,
  soldedNumElite: 0,
  updateAt: undefined,
};

export const saleBoardSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    updateSaleBoardData: (state, action) => {
      if (
        action.payload?.saleAmount &&
        action.payload?.saleAmount > state.saleAmount
      ) {
        state.saleAmount = action.payload.saleAmount;
      }
      if (
        action.payload?.soldedNumNormal &&
        action.payload?.soldedNumNormal > state.soldedNumNormal
      ) {
        state.soldedNumNormal = action.payload.soldedNumNormal;
      }
      if (
        action.payload?.soldedNumRare &&
        action.payload?.soldedNumRare > state.soldedNumRare
      ) {
        state.soldedNumRare = action.payload.soldedNumRare;
      }
      if (
        action.payload?.soldedNumElite &&
        action.payload?.soldedNumElite > state.soldedNumElite
      ) {
        state.soldedNumElite = action.payload.soldedNumElite;
      }

      if (action.payload?.updateAt) {
        state.updateAt = action.payload.updateAt;
      }
    },
  },
});

export const { updateSaleBoardData } = saleBoardSlice.actions;

export default saleBoardSlice.reducer;
